import { Link } from "react-router-dom"
import Button from 'react-bootstrap/Button';

function Footer() {
  return(
     <>
  <div className="footer footer-1">
    <div className="footer-top clearfix">
      <div className="container">
        <div className="row">
          <div className="col-12 col-sm-12 col-md-4 col-lg-3 about-us-col">
            <p>
              55 Gallaxy Enque,
              <br />
              2568 steet, 23568 NY
            </p>
            <p>
              <b>Email</b>:{" "}
              <Link to="mailto:sales@yousite.com">sales@yousite.com</Link>
            </p>
            {/* <ul className="list--inline social-icons">
              <li>
                <a href="#" target="_blank">
                  <i className="bi bi-facebook" />
                </a>
              </li>
        
              <li>
                <a href="#" target="_blank">
                  <i className="bi bi-instagram" />
                </a>
              </li>
              <li>
                <a href="#" target="_blank">
                  <i className="bi bi-youtube" />
                </a>
              </li>
            </ul> */}
          </div>
          <div className="col-12 col-sm-12 col-md-4 col-lg-3 footer-links">
            <h4 className="h4">Quick Links</h4>
            <ul>
              <li>
                <Link to="/">Bath Set </Link>
              </li>
              <li>
                <Link to="/">Dustbin</Link>
              </li>
              <li>
                <Link to="/">Carpet</Link>
              </li>
              <li>
                <Link to="/">ParaShoot</Link>
              </li>
              <li>
               <Link to="/">Sale</Link>
              </li>
            </ul>
          </div>
          <div className="col-12 col-sm-12 col-md-4 col-lg-3 footer-links">
            <h4 className="h4">Informations</h4>
            <ul>
              <li>
                <Link to="aboutus-style1.html">About us</Link>
              </li>
              
              <li>
                <Link to="privacy-policy.html">Privacy policy</Link>
              </li>
              <li>
              <Link to="/">Terms &amp; condition </Link>
              </li>
              <li>
                <Link to="my-account.html">My Account</Link>
              </li>
            </ul>
          </div>
         
          <div className="col-12 col-sm-12 col-md-4 col-lg-4 newsletter-col">
            <div className="display-table">
              <div className="display-table-cell footer-newsletter">
                <form action="#" method="post">
                  <label className="h4">Newsletter</label>
                      <p>
                        Enter your email to receive daily news and get 20% off coupon
                        for all items.
                      </p>

                  <div className="input-group">
                    <input
                      type="email"
                      className="input-group__field newsletter-input"
                      name="EMAIL"
                      defaultValue=""
                      placeholder="Email address"
                      required=""
                      style={{ width: "70%"}}
                    />
                    <span className="input-group__btn">
                      <Button
                        type="submit"
                        className="btn newsletter__submit"
                        name="commit"
                        id="Subscribe"
                        style={{ height: "40px"}}
                      >
                      <span className="newsletter__submit-text--large">
                        Subscribe
                      </span>
                      </Button>
                    </span>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  <div style={{ padding: "20px", textAlign: "center"}}>   2025. All Rights Reserved.</div>
</div>
 
</>
  )
}
export default Footer;